<template>
	<div class="themes-header mb-4">
		<div class="d-flex align-items-center justify-content-between">
			<div class="d-flex flex-column">
				<div v-if="title" class="title title-lg">
					{{ title }}
				</div>
				<p v-if="description">
					{{ description }}
				</p>
			</div>
			<div class="d-flex">
				<div v-if="withThemes" class="d-none d-lg-flex mr-3">
					<ThemesButton :themes="selectedTags" @click="visible = !visible" />
				</div>
				<slot name="link-button" />
			</div>
		</div>
		<ThemesButton
			v-if="withThemes"
			class="w-100 d-lg-none mt-2 mr-3"
			:themes="selectedTags"
			@click="visible = !visible"
		/>
		<TagsOfRecommendation
			v-model="selectedTags"
			:is-visible="visible"
			@setVisible="(value) => (visible = value)"
			@reset="resetTags"
		>
			<slot name="tags" />
		</TagsOfRecommendation>
	</div>
</template>

<script>
import ThemesButton from '~/components/buttons/ThemesButton.vue';
import recommendationTags from '~/mixins/recommendationTags';
import TagsOfRecommendation from '~/components/panels/PanelUserRecommendations/TagsOfRecommendation.vue';

export default {
	name: 'PanelThemesHeader',
	components: { TagsOfRecommendation, ThemesButton },
	mixins: [recommendationTags],
	props: {
		title: {
			type: String,
			default: null,
		},
		description: {
			type: String,
			default: null,
		},
		withThemes: {
			type: Boolean,
			default: true,
		},
	},
	data() {
		return {};
	},
};
</script>

<style lang="scss" scoped>
@import "assets/styles/sk_variables";
// For use bootstrap vars and mixins inside
@import "assets/styles/bootstrap/scss/functions";
@import "assets/styles/bootstrap/scss/variables";
@import "assets/styles/bootstrap/scss/mixins";

.title-lg {
	margin-bottom: 0;
}

.themes-header {
	display: flex;
	flex-direction: column;

	@include media-breakpoint-down(md) {
		gap: 1rem;
	}
}
</style>
